module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE4IDZWMEgwVjE4SDZWMjRIMjRWNkgxOFpNNiAxNkgyVjJIMTZWNkg2VjE2Wk0yMiAyMkg4VjhIMjJWMjJaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/copy.svg
// module id = zsfP
// module chunks = 31